import { useSession } from "@outschool/ui-auth";
import { useQueryParams } from "@patched/hookrouter";
import { useLocation } from "react-router";

export const useIsPaidLandingPage = () => {
  const { isLoggedIn } = useSession();
  const [{ utm_medium }] = useQueryParams();
  const isAdTraffic =
    utm_medium?.startsWith("ads") || utm_medium?.startsWith("paid");
  const location = useLocation();
  const isClp =
    location.pathname.includes("/landing/") ||
    location.pathname.includes("/online-classes/");
  const isPaidClp = !isLoggedIn && isAdTraffic && isClp;
  return isPaidClp;
};
